import { render, staticRenderFns } from "./TableLvl3.vue?vue&type=template&id=7c1a5df4"
import script from "./TableLvl3.vue?vue&type=script&lang=js"
export * from "./TableLvl3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports